import React from 'react'

function TenderTextIGMLB() {
  return (
    <embed src="\pdfs\EAT2.5.2.3_IG-M-LB_Induction_unit_for_mixing_ventilation_for_horizontal_floor_mounting_kr.pdf" width="100%" height="2100px" />
  )
}

export default TenderTextIGMLB